export const ORDERS__LOAD_TRACKING_NUMBERS = 'ORDERS__LOAD_TRACKING_NUMBERS';
export const ORDERS__LOAD_TRACKING_NUMBERS_FULFILLED = `${ORDERS__LOAD_TRACKING_NUMBERS}_FULFILLED`;
export const ORDERS__LOAD_TRACKING_NUMBERS_PENDING = `${ORDERS__LOAD_TRACKING_NUMBERS}_PENDING`;

export const ORDERS__UPDATE_SHIPMENTS = 'ORDERS_UPDATE_SHIPMENTS';
export const ORDERS__DELETE_SHIPMENT = 'ORDERS_DELETE_SHIPMENT';
